import Layout from "layouts";
import React from "react";
import FlavourAddComponent from "./FlavourAddComponent";

export default function FlavourDetails() {
  return (
    <Layout
      breadCrumb={[
        { label: "Flavours", to: "/flavours" },
        { label: "Add New Flavour", to: "#" },
      ]}
    >
      <FlavourAddComponent />
    </Layout>
  );
}
